import { CustomerDispatchTypes, CUSTOMER_LOADING, CUSTOMER_SUCCESS, CUSTOMER_FAIL } from "../actions/customerActionTypes";


interface DefaultStateI {

    loading: boolean,
    customerInfo?: any,
    msg?: string

}


const defaultState: DefaultStateI = {

    loading: false,
    // customerInfo: [ ],
    msg: ''

}


const customerReducer = ( state: DefaultStateI = defaultState, action: CustomerDispatchTypes ): DefaultStateI => {

    switch( action.type ) {

        case CUSTOMER_FAIL:
            return {
                loading: false,
                customerInfo: [ ],
                msg: action.payload
            }
        case CUSTOMER_LOADING:
            return {
                loading: true
            }
        case CUSTOMER_SUCCESS:
            return {

                loading: false,
                customerInfo: action.payload

            }
        default:
            return state

    }
}

export default customerReducer;